import React from "react";
import { ChatPanelHeader } from "../../molecules/ChatPanelHeader";
import { CommandList } from "../../molecules/CommandList";
import { PromptInputBar } from "../../molecules/PromptInputBar";
import { SCREEN_ASSISTANT_COPY as COPY } from "./ScreenAssistantPanel.copy";
import { Body, Footer, Panel, Result, SectionTitle } from "./ScreenAssistantPanel.styles";
import { useScreenAssistantPanelInternalState } from "./useScreenAssistantPanelInternalState";

/**
 * The generic MagicBI panel, mounted once in the app shell. It answers Mod+/ and the navbar MagicBI icon on screens
 * that have no panel of their own: it names the screen, lists the commands that are ready on it, and runs typed requests.
 */
export const ScreenAssistantPanel: React.FC = () => {
  const s = useScreenAssistantPanelInternalState();
  return (
    <Panel $open={s.visible} role="complementary" aria-label={COPY.region} aria-hidden={!s.visible}>
      <ChatPanelHeader title={COPY.title} subtitle={`${COPY.contextPrefix} ${s.screenLabel}`} onCollapse={s.close} />
      <Body>
        <SectionTitle>{COPY.sectionTitle}</SectionTitle>
        <CommandList
          groups={s.groups}
          activeId={null}
          listboxId="screen-assistant-actions"
          label={COPY.listLabel}
          emptyLabel={COPY.empty}
          onSelect={(id) => { void s.runAction(id); }}
        />
        {s.result && <Result role="status">{s.result}</Result>}
      </Body>
      <Footer>
        <PromptInputBar
          variant="assistant"
          hideUpload
          placeholder={COPY.placeholder}
          hint={COPY.hint}
          value={s.text}
          onChange={s.setText}
          onSend={() => { void s.send(); }}
        />
      </Footer>
    </Panel>
  );
};

export default ScreenAssistantPanel;
